module.exports = __webpack_public_path__ + "img/type_32-b-150_6.prt.f951bd03.jpg";